import {
  Component,
  Output,
  EventEmitter,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { CoreService } from 'src/app/services/core.service';
import { MatDialog } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Router, RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { TablerIconsModule } from 'angular-tabler-icons';
import { FormsModule } from '@angular/forms';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { BrandingComponent, } from '../sidebar/branding.component';
import { AuthService } from 'src/app/services/auth.service';
import { firstValueFrom, Subscription } from 'rxjs';
import { PopupComponent } from 'src/app/pages/dashboards/popup/popup.component';
import { TranslationsManagementService } from 'src/app/services/translations-management.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

interface notifications {
  id: number;
  img: string;
  title: string;
  subtitle: string;
}

interface msgs {
  id: number;
  img: string;
  title: string;
  subtitle: string;
}

interface profiledd {
  id: number;
  img: string;
  title: string;
  subtitle: string;
  link: string;
}

@Component({
  selector: 'search-dialog',
  standalone: true,
  imports: [RouterModule, MaterialModule, TablerIconsModule, FormsModule, TranslateModule],
  templateUrl: 'search-dialog.component.html'
})
export class AppSearchDialogComponent {
  searchText: string = '';
}



@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterModule, NgScrollbarModule, TablerIconsModule, MaterialModule, BrandingComponent, AppSearchDialogComponent, TranslateModule],
  templateUrl: './header.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./header.component.scss']
})


export class HeaderComponent {
  @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleMobileFilterNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();

  showFiller = false;
  userData: any;

  supportEmail: string = "sunrise_support@iti.gr";
  userId: number = 0;
  emailSubject: string = "SUNRISE project";
  emailBody: string = "Type the issue here: ";

  public selectedLanguage: any = {
    language: 'English',
    code: 'en',
    type: 'EN',
    icon: '/assets/images/flag/icon-flag-en.png',
    emailSubject: 'SUNRISE project Authoring tool · User Id',
    emailBody: 'Type the issue here: '
  };

  public languages: any[] = [
    {
      language: 'English',
      code: 'en',
      type: 'EN',
      icon: '/assets/images/flag/icon-flag-en.png',
      emailSubject: 'SUNRISE project Authoring tool · User Id',
      emailBody: 'Type the issue here: '
    },
    {
      language: 'Italiano / Italian',
      code: 'it',
      type: 'IT',
      icon: '/assets/images/flag/icon-flag-it.png',
      emailSubject: 'Progetto SUNRISE Authoring tool · ID utente ',
      emailBody: 'Scrivi qui il problema:'
    },
    {
      language: 'Nederlands / Dutch',
      code: 'nl',
      icon: '/assets/images/flag/icon-flag-nl.png',
     emailSubject: 'SUNRISE-project Authoring tool · Gebruikers-ID ',
      emailBody: 'Typ hier het probleem:'
    },
    {
      language: 'Euskara / Basque',
      code: 'eu',
      icon: '/assets/images/flag/icon-flag-eu.png',
      emailSubject: 'SUNRISE proiektua Authoring tool · Erabiltzaile-IDa ',
      emailBody: 'Idatzi arazoa hemen:'
    },
    {
      language: 'Català-Valencià / Catalan-Valencian',
      code: 'ca',
      icon: '/assets/images/flag/icon-flag-ca.png',
      emailSubject: 'Projecte SUNRISE Authoring tool · ID d\'usuari ',
      emailBody: 'Escriu el problema aquí:'
    },
    {
      language: 'Español / Spanish',
      code: 'es',
      icon: '/assets/images/flag/icon-flag-es.svg',
      emailSubject: 'Proyecto SUNRISE Authoring tool · ID de usuario ',
      emailBody: 'Escribe el problema aquí:',
    },
    {
      language: 'Slovenščina / Slovenian',
      code: 'sl',
      icon: '/assets/images/flag/icon-flag-sl.png',
      emailSubject: 'Projekt SUNRISE Authoring tool · ID uporabnika ',
      emailBody: 'Vnesite težavo tukaj:'
    },
    {
      language: 'Ελληνικά / Greek',
      code: 'el',
      icon: '/assets/images/flag/icon-flag-el.png',
      emailSubject: 'Έργο SUNRISE Authoring tool · Ταυτότητα χρήστη ',
      emailBody: 'Πληκτρολογήστε το πρόβλημα εδώ:'
    },
    {
      language: 'Română / Romanian',
      code: 'ro',
      icon: '/assets/images/flag/icon-flag-ro.png',
      emailSubject: 'Proiectul SUNRISE Authoring tool · ID utilizator ',
      emailBody: 'Scrie problema aici:'
    },
    {
      language: 'Deutsch / German',
      code: 'de',
      icon: '/assets/images/flag/icon-flag-de.png',
      emailSubject: 'SUNRISE-Projekt Authoring tool · Benutzer-ID ',
      emailBody: 'Geben Sie das Problem hier ein:'
    }
  ];

  userManualPdfUrl: SafeResourceUrl;

  /** Data subscriptions */
  private changeLanguageSubscription: Subscription = new Subscription();

  constructor(
    private vsidenav: CoreService,
    public dialog: MatDialog,
    private translate: TranslateService,
    private authService: AuthService,
    private router: Router,
    private translationsManagementService: TranslationsManagementService,
    private sanitizer: DomSanitizer
  ) {
    this.userManualPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl('/assets/Authoring tool user manual v1.pdf');
    const language = localStorage.getItem('language');
    const found = this.languages.find((item: any) => item.code === language);
    this.selectedLanguage = found ? found : {
      language: 'English',
      code: 'en',
      type: 'EN',
      icon: '/assets/images/flag/icon-flag-en.png',
      emailSubject: 'SUNRISE project · User Id',
      emailBody: 'Type the issue here: '
    };

    this.userData = this.authService.userSessionInfo;

  }

  ngOnInit() {

    this.changeLanguageSubscription = this.translationsManagementService.languageChanged$.subscribe((data: any) => {

    const language = localStorage.getItem('language');
    const found = this.languages.find((item: any) => item.code === language);
    this.selectedLanguage = found ? found : {
      language: 'English',
      code: 'en',
      type: 'EN',
      icon: '/assets/images/flag/icon-flag-en.png',
      emailSubject: 'SUNRISE project Authoring tool · User Id',
      emailBody: 'Type the issue here: '
    };

    this.emailSubject = this.selectedLanguage.emailSubject;
    this.emailBody = this.selectedLanguage.emailBody;
    

    })

    if(this.authService.pilot) {
      this.supportEmail = ("sunrise_support_" + this.authService.pilot + "@iti.gr").toLowerCase();
      this.userId = this.authService.uuid;
      this.emailSubject = this.selectedLanguage.emailSubject;
      this.emailBody = this.selectedLanguage.emailBody;
    }

  }

  openDialog() {
    const dialogRef = this.dialog.open(AppSearchDialogComponent);

    dialogRef.afterClosed().subscribe((result) => {
    });
  }

  changeLanguage(lang: any): void {
    this.translationsManagementService.changeLanguage(lang.code);
    this.selectedLanguage = lang;
  }

  async logout() {

    let sessionElapsedTimeInSeconds = Math.round((new Date().getTime() - this.authService.loginTime) / 1000);

    try {
      await firstValueFrom(this.authService.updateLogsSessionDuration(sessionElapsedTimeInSeconds, this.authService.logId));
      this.authService.cleanVariables();
      this.authService.logoutClean();
      this.router.navigate(['/']);

    } catch (error: any) {

      let errorText = "error" + error.status

      //Error Popup 401
      if (errorText.indexOf("error401") != -1) {
        this.showErrorPopUp("general.errorMessageSessionExpired");
      } else {
        this.showErrorPopUp("general.errorMessage");
      }

      throw new Error(`Error in updateLogsSessionDuration() method with user id: ${this.authService.uuid} + ${this.authService.pilot}, error ${(error.status ?? 'error status not available')}, description ${(JSON.stringify(error.message) ?? 'error message not available')}, error  ${(JSON.stringify(error.error) ?? 'error.error not available')}`);

    }

  }

  /**
* Pop-up to show an error ocurred
*/
  showErrorPopUp(message: string) {

    //SHOW ERROR POPUP
    this.dialog.open(PopupComponent, {
      disableClose: true,
      width: '640px',
      height: '160px',
      data: {
        type: "attentionInfo",
        headerText: this.translate.instant("login.attention"),
        generalText: this.translate.instant(message),
        button: ["Ok"]
      },
    }).afterClosed().subscribe(async (result) => {

      if (message == 'general.errorMessageSessionExpired') {
        this.router.navigate(['/']);
      }

    })

  }

  notifications: notifications[] = [
    {
      id: 1,
      img: '/assets/images/profile/user-1.jpg',
      title: 'Roman Joined the Team!',
      subtitle: 'Congratulate him',
    },
    {
      id: 2,
      img: '/assets/images/profile/user-2.jpg',
      title: 'New message received',
      subtitle: 'Salma sent you new message',
    },
    {
      id: 3,
      img: '/assets/images/profile/user-3.jpg',
      title: 'New Payment received',
      subtitle: 'Check your earnings',
    },
    {
      id: 4,
      img: '/assets/images/profile/user-4.jpg',
      title: 'Jolly completed tasks',
      subtitle: 'Assign her new tasks',
    },
    {
      id: 5,
      img: '/assets/images/profile/user-5.jpg',
      title: 'Roman Joined the Team!',
      subtitle: 'Congratulate him',
    },
  ];

  msgs: msgs[] = [
    {
      id: 1,
      img: '/assets/images/profile/user-1.jpg',
      title: 'Andrew McDownland',
      subtitle: 'Message blocked. Try Again',
    },
    {
      id: 2,
      img: '/assets/images/profile/user-2.jpg',
      title: 'Christopher Jamil',
      subtitle: 'This message cannot be sent',
    },
    {
      id: 3,
      img: '/assets/images/profile/user-3.jpg',
      title: 'Julia Roberts',
      subtitle: 'You are trying to reach location.',
    },
    {
      id: 4,
      img: '/assets/images/profile/user-4.jpg',
      title: 'James Johnson',
      subtitle: 'Assign her new tasks',
    },
    {
      id: 5,
      img: '/assets/images/profile/user-5.jpg',
      title: 'Maria Rodriguez',
      subtitle: 'Congrats for your success',
    },
  ];

  profiledd: profiledd[] = [
    {
      id: 1,
      img: '/assets/images/svgs/icon-account.svg',
      title: 'My Profile',
      subtitle: 'Account Settings',
      link: '/',
    },
    {
      id: 2,
      img: '/assets/images/svgs/icon-inbox.svg',
      title: 'My Inbox',
      subtitle: 'Messages & Email',
      link: '/apps/email/inbox',
    },
    {
      id: 3,
      img: '/assets/images/svgs/icon-tasks.svg',
      title: 'My Tasks',
      subtitle: 'To-do and Daily Tasks',
      link: '/apps/taskboard',
    },
  ];
}

